import React, { useState } from 'react';
import { 
    Star, 
    ShieldCheck, 
    Leaf, 
    Package, 
    ChevronRight,
    Info,
    ArrowRight
  } from 'lucide-react';
const FeaturedProducts = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    
    const products = [
      {
        name: "Organic Cotton Pads",
        description: "Experience ultimate comfort with our ultra-soft, breathable organic cotton daily pads. Designed with your wellbeing and the environment in mind, these pads feature naturally absorbent materials that keep you feeling fresh throughout the day.",
        features: ["100% Organic Cotton", "Breathable Design", "Plastic-Free"],
        tag: "Featured"
      },
      // {
      //   name: "Organic Night Pads",
      //   description: "Rest easy with our extra-coverage organic night pads. Made with multiple layers of pure cotton for maximum protection, these pads ensure peaceful nights while maintaining the highest standards of comfort and sustainability.",
      //   features: ["Extra Coverage", "Super Absorbent", "100% Natural"],
      //   tag: "Essential"
      // },
      // {
      //   name: "Cotton Liners",
      //   description: "Stay fresh daily with our ultra-thin organic cotton liners. Perfect for light days, these breathable liners provide reliable protection while being gentle on your skin and kind to the environment.",
      //   features: ["Ultra Thin", "Daily Comfort", "Eco-Friendly"],
      //   tag: "Everyday"
      // }
    ];
  
    return (
      <div className="bg-gradient-to-br from-[#679729]/5 to-white rounded-3xl p-8 mt-20 mb-16">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-between mb-8">
            <h2 className="text-3xl font-bold text-gray-800">Featured Products</h2>
            <div className="flex gap-2">
              {products.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveIndex(idx)}
                  className={`w-3 h-3 rounded-full transition-all ${
                    idx === activeIndex ? 'bg-[#679729] scale-125' : 'bg-gray-300'
                  }`}
                />
              ))}
            </div>
          </div>
  
          <div className="grid lg:grid-cols-2 gap-8 items-center">
            <div className="relative group">
              <div className="absolute inset-0 bg-[#679729]/10 rounded-2xl transform -rotate-6 group-hover:rotate-0 transition-transform duration-300" />
              <img 
                src="/images/product-image.png"
                alt={products[activeIndex].name}
                className="rounded-2xl shadow-lg w-full relative z-10"
              />
              <div className="absolute top-4 left-4 bg-[#679729] text-white px-4 py-1 rounded-full text-sm font-medium z-20">
                {products[activeIndex].tag}
              </div>
            </div>
  
            <div className="space-y-6">
              <div className="flex items-center gap-2 text-[#679729]">
                <ShieldCheck size={20} />
                <span className="text-sm font-medium">Certified Organic</span>
              </div>
              
              <h3 className="text-4xl font-bold text-gray-800">
                {products[activeIndex].name}
              </h3>
              
              <p className="text-gray-600 text-lg leading-relaxed">
                {products[activeIndex].description}
              </p>
  
              <div className="space-y-3">
                {products[activeIndex].features.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-2">
                    <Leaf className="w-5 h-5 text-[#679729]" />
                    <span className="text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  export default FeaturedProducts;